import * as React from 'react'
import styled from 'styled-components'
import { useFlag } from 'toggled'

import { SortSelect } from '~/components/filters/components/sort-select'
import { PageTitleWithTotal } from '~/components/page-title-with-total'
import { flags } from '~/utils/constants'

export interface HeaderDesktopProps {
  title: string
  numOfHints: number
}

const StyledHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.comfortable}px;
  padding-bottom: ${props => props.theme.spacing.cozy}px;
  width: 100%;
`

const StyledHeaderActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing.cozy * 1.5}px;
`

export function HeaderDesktop(props: HeaderDesktopProps) {
  const { title, numOfHints } = props

  const hasProductSortingFF = useFlag(flags.PRODUCT_SORTING)

  return (
    <>
      <StyledHeaderContainer>
        <PageTitleWithTotal title={title} total={numOfHints} />
        <StyledHeaderActionsContainer>{hasProductSortingFF && <SortSelect />}</StyledHeaderActionsContainer>
      </StyledHeaderContainer>
    </>
  )
}
